import React, { useCallback, useEffect, useState } from 'react';

import { BWModal } from 'components/shared/BWModal';
import { PortalIcon } from 'utils/baochauTheme';
import { UNPAID_ORDER_NOTICE_EVENT } from 'utils/unpaidOrderNotice';
import './style.scss';

const UnpaidOrderModal = () => {
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    const handleNotice = (event) => setNotice(event.detail || {});
    window.addEventListener(UNPAID_ORDER_NOTICE_EVENT, handleNotice);
    return () => window.removeEventListener(UNPAID_ORDER_NOTICE_EVENT, handleNotice);
  }, []);

  const handleClose = useCallback(() => setNotice(null), []);

  const handleGoToPayment = useCallback(() => {
    const paymentPath = notice?.paymentPath;
    if (!paymentPath) return;

    setNotice(null);
    window._$g?.rdr?.(paymentPath);
  }, [notice]);

  return (
    <BWModal
      open={Boolean(notice)}
      title={
        <span className='bw_unpaid_order_title'>
          <span className='bw_unpaid_order_icon' aria-hidden='true'>
            <PortalIcon icon='fi fi-rr-exclamation' />
          </span>
          <span>Đơn hàng chưa thanh toán</span>
        </span>
      }
      description={
        <>
          Đơn hàng hiện tại chưa được thanh toán đầy đủ.
          <br />
          Bạn có muốn tiếp tục chỉnh sửa hay chuyển sang thanh toán?
        </>
      }
      size='sm'
      modalClassName='bw_unpaid_order_modal'
      bodyClassName='bw_unpaid_order_body'
      testId='unpaid-order-modal'
      maskClosable={false}
      onClose={handleClose}
      cancelAction={{ label: 'Tiếp tục chỉnh sửa' }}
      primaryAction={
        notice?.paymentPath
          ? {
              label: 'Đi đến thanh toán',
              onClick: handleGoToPayment,
            }
          : null
      }
    />
  );
};

export default UnpaidOrderModal;
